var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OUTLINE_copy_2",
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm3.488,16H17.249v8.124H13.892V16H12.215V13.2h1.677V11.519c0-2.284.947-3.642,3.637-3.642h2.24v2.8h-1.4c-1.047,0-1.117.392-1.117,1.121l0,1.4h2.536l-.3,2.8Z",
    fill: "#faf7f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c0659606767a229c8f3b4e8f81791e5a.svg";
export { ForwardRef as ReactComponent };